import { DecimalPipe, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  InputSignal,
  ModelSignal,
  OutputEmitterRef,
  Signal,
  TemplateRef,
  computed,
  input,
  model,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { TreeFacet } from '@mp/shared/facets/domain';

@Component({
  selector: 'mp-tree-facet-bucket',
  templateUrl: './tree-facet-bucket.component.html',
  styleUrl: './tree-facet-bucket.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'mp-tree-facet-bucket',
    '[class.mp-tree-facet-bucket--selected]': 'isSelected()',
  },
  imports: [NgTemplateOutlet, MatIconModule, DecimalPipe],
})
export class TreeFacetBucketComponent<TData extends object | unknown = unknown> {
  readonly bucket: InputSignal<TreeFacet.Bucket<TData>> = input.required<TreeFacet.Bucket<TData>>();

  readonly isSelected: InputSignal<boolean> = input<boolean>(false);

  readonly isExpanded: ModelSignal<boolean> = model<boolean>(false);

  readonly bucketClick: OutputEmitterRef<void> = output<void>();

  @ContentChild(TemplateRef)
  protected bucketChildrenTemplate?: TemplateRef<unknown>;

  protected readonly bucketTooltip: Signal<string> = computed(() => `${this.bucket().value} | ${this.bucket().label}`);

  protected readonly hasBucketAnyChildren: Signal<boolean> = computed(() => (this.bucket().children?.length ?? 0) > 0);

  toggleBucketExpanded(): void {
    this.isExpanded.set(!this.isExpanded());
  }

  onBucketClick(): void {
    this.bucketClick.emit();
  }
}
